module.exports = __webpack_public_path__ + "static/img/weathericons-regular-webfont.b2233bc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/weather-icons/font/weathericons-regular-webfont.svg
// module id = 634
// module chunks = 1